import { Title } from '@buildwise/libs/posts/components/PostDetails/PostInfo';
import { ArticleType } from '@buildwise/pages/knowledge/hooks/useArticlesQuery';
import { Box, Typography } from '@mui/material';
import UserAvatar from 'components/common/userAvatar/UserAvatar';

type QuestionAskedByProps = {
  article: ArticleType;
};

function QuestionAskedBy({ article }: QuestionAskedByProps) {
  return (
    <>
      <Title>Asked By</Title>
      <Box mt={-1}>
        {article?.questionCreatedBy ? (
          <UserAvatar
            isSmall
            title={article?.questionCreatedByDisplayName}
            avatarName={article?.questionCreatedByDisplayName}
            userName={article?.questionCreatedBy}
            subTitle={article?.questionCreatedByTitleToDisplay}
            profileImageURL={article?.questionCreatedByProfileImageURL}
          />
        ) : (
          <Typography>Anonymous</Typography>
        )}
      </Box>
    </>
  );
}

export default QuestionAskedBy;
